import { Component, input, output, EventEmitter } from "@angular/core";

@Component({
  selector: "app-collapsible-card",
  templateUrl: "./collapsible-card.component.html",
})
export class CollapsibleCardComponent {
  headerIcon = input<string>("");
  headerTitle = input<string>("");
  showProgress = input<boolean>(false);
  hideHeaderOnDesktop = input<boolean>(false);
  hideChevron = input<boolean>(false);

  isExpanded = input<boolean>(false);
  isExpandedChange = output<boolean>();

  toggleExpanded(): void {
    this.isExpandedChange.emit(!this.isExpanded());
  }

  onHeaderClick(event: MouseEvent): void {
    if (this.isProjectedInteractiveTarget(event)) {
      return;
    }
    this.toggleExpanded();
  }

  onHeaderKey(event: Event, isSpace = false): void {
    if (this.isProjectedInteractiveTarget(event)) {
      return;
    }
    if (isSpace) {
      event.preventDefault();
    }
    this.toggleExpanded();
  }

  private isProjectedInteractiveTarget(event: Event): boolean {
    return !!(event.target as HTMLElement).closest("button, a, input, select, textarea");
  }
}
